module.exports = __webpack_public_path__ + "static/media/loupeInFile.57dfbc70.svg";